var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 3.6a3.3 3.3 0 1 1-6.6 0 3.3 3.3 0 0 1 6.6 0zM18.8 5.8a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zM14.4 13.5a4.4 4.4 0 0 0-8.8 0v3.3h8.8zM5.6 5.8a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zM16.6 16.8v-3.3a6.57 6.57 0 0 0-.824-3.196A3.3 3.3 0 0 1 19.9 13.5v3.3zM4.224 10.304A6.57 6.57 0 0 0 3.4 13.5v3.3H.1v-3.3a3.3 3.3 0 0 1 4.124-3.196z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.ccfd99aeaa04d8b342533055d032fc84.svg";
export { ForwardRef as ReactComponent };